export default __webpack_public_path__ + "static/logo24-cc043a1cb63240495f338f307f5c1799.png";